import { Injectable } from '@angular/core';
import { GroupsOfGroup, GroupsService, UsersService } from '@era/security-sdk';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap } from 'rxjs/operators';
import { GroupsOfGroupResolverActions, GroupApiActions } from './groups-of-group.actions';
import { safeMap } from '../effects.helpers';

@Injectable()
export class GroupsOfGroupEffects {
  constructor(
    private readonly userService: UsersService,
    private readonly groupService: GroupsService,
    private readonly actions$: Actions
  ) {}

  groupsOfGroupLoadedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(GroupsOfGroupResolverActions.userGroupsRequested),
      mergeMap(({ groupId }) =>
        safeMap(
          this.groupService.getGroupsOfGroup(groupId),
          (groups: GroupsOfGroup[]) => GroupApiActions.userGroupsLoaded({ groups }),
          (error) => GroupApiActions.userGroupsLoadedError({ error })
        )
      )
    );
  });
}
